import React, { useState } from 'react';
import styled from '@emotion/native';
import { Title } from './styledComponents';
import useExploreStore from '@/stores/useExploreStore';
import { SessionType } from '@/shared/types/generated';
import { useEventConfiguration } from '@/shared/hooks/useEventConfiguration';
import InPersonInfoTile from '../InPersonInfoTile';
import Dropdown from '@/shared/components/Dropdown';

interface DropdownOption {
  label: string;
  value: string | number;
}

const SessionTypeFilter = ({
  isCalendarComponent,
}: {
  isCalendarComponent?: boolean;
}) => {
  const { filters, setFilters } = useExploreStore();
  const { inPersonEventSessions } = useEventConfiguration();
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const selected = filters.sessionType;

  // Base options always available
  const sessionTypeOptions: DropdownOption[] = [
    { label: 'All', value: 'all' },
    { label: 'Video Sessions', value: SessionType.Video },
    { label: 'In-Person at Event', value: SessionType.InPersonEvent },
  ];

  const getSelectedValue = () => {
    if (selected === SessionType.Video) return SessionType.Video;
    if (selected === SessionType.InPersonEvent) {
      return SessionType.InPersonEvent;
    }
    if (selected === null) return 'all';
    return 'all'; // Default to All
  };

  const getSelectedLabel = () => {
    const option = sessionTypeOptions.find(
      (opt) => opt.value === getSelectedValue(),
    );
    return option?.label || 'All';
  };

  const handleSelect = (option: DropdownOption) => {
    if (option.value === 'all') {
      setFilters({ sessionType: null });
    } else {
      setFilters({ sessionType: option.value as SessionType });
    }
  };

  const showImage =
    selected === SessionType.InPersonEvent && inPersonEventSessions;

  return (
    <Container isCalendarComponent={isCalendarComponent}>
      <Title>Select the session type:</Title>
      <Dropdown
        eyebrowText="Session Type"
        options={sessionTypeOptions}
        selectedOption={getSelectedValue()}
        selectedOptionLabel={getSelectedLabel()}
        onSelect={handleSelect}
        isVisible={isDropdownVisible}
        setIsVisible={setIsDropdownVisible}
      />
      {showImage && <InPersonInfoTile />}
    </Container>
  );
};

const Container = styled.View(
  ({ isCalendarComponent }: { isCalendarComponent?: boolean }) => ({
    marginBottom: !isCalendarComponent ? 16 : 0,
    paddingHorizontal: isCalendarComponent ? 32 : 0,
  }),
);

export default SessionTypeFilter;
